export enum Allergens {
  Altramuces = 1,
  Apio = 2,
  Cacahuates = 4,
  Crustaceos = 8,
  FrutosSecos = 16,
  Gluten = 32,
  Huevos = 64,
  Lacteos = 128,
  Moluscos = 256,
  Mostaza = 512,
  Pescado = 1024,
  Sesamo = 2048,
  Soja = 4096,
  Sulfitos = 8192,
}

export const allergensNames = {
  [Allergens.Altramuces]: 'allergens.lupins',
  [Allergens.Apio]: 'allergens.celery',
  [Allergens.Cacahuates]: 'allergens.peanuts',
  [Allergens.Crustaceos]: 'allergens.crustaceans',
  [Allergens.FrutosSecos]: 'allergens.nuts',
  [Allergens.Gluten]: 'allergens.gluten',
  [Allergens.Huevos]: 'allergens.eggs',
  [Allergens.Lacteos]: 'allergens.dairy',
  [Allergens.Moluscos]: 'allergens.mollusks',
  [Allergens.Mostaza]: 'allergens.mustard',
  [Allergens.Pescado]: 'allergens.fish',
  [Allergens.Sesamo]: 'allergens.sesame',
  [Allergens.Soja]: 'allergens.soy',
  [Allergens.Sulfitos]: 'allergens.sulphites',
};

const allArr = [];
for (let a in Allergens) {
  const val = parseInt(a, 10);
  const isNumber = val >= 0;
  if (isNumber) {
    const allergen = {
      name: allergensNames[a],
      picture: Allergens[a].toLowerCase(),
      id: val,
    };
    allArr.push(allergen);
  }
}
export const allergens = allArr;
